import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { KatSpinner } from '@amzn/katal-react';
import { Amplify } from 'aws-amplify';
import { AuthProvider } from 'react-oidc-context';

import App from './App';
import AppInitWrapper from './components/AppInitWrapper';
import { amplifyConfig } from './amplifyConfig';
import { currentConfig } from './config';

import '@amzn/katal-components/styles.css';
import './index.scss';

// Configure Amplify with mock values for development
Amplify.configure(amplifyConfig);

// Configuration for react-oidc-context (OIDC authentication)
const cognitoAuthConfig = currentConfig.auth ? {
  authority: currentConfig.auth.authority,
  client_id: currentConfig.auth.client_id,
  redirect_uri: currentConfig.redirectUri,
  response_type: "code",
  scope: currentConfig.auth.scope,
  loadUserInfo: true,
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
    window.location.href = currentConfig.redirectUri;
  },
  automaticSilentRenew: true,
} : null;

const container = document.getElementById('root');
const root = createRoot(container!);

// For CloudFront deployment, use OIDC authentication
// For other environments, use simplified setup
root.render(
    <React.StrictMode>
        <BrowserRouter>
            {cognitoAuthConfig ? (
                <AuthProvider {...cognitoAuthConfig}>
                    <AppInitWrapper>
                        <React.Suspense fallback={<KatSpinner size="large" />}>
                            <App />
                        </React.Suspense>
                    </AppInitWrapper>
                </AuthProvider>
            ) : (
                <AppInitWrapper>
                    <React.Suspense fallback={<KatSpinner size="large" />}>
                        <App />
                    </React.Suspense>
                </AppInitWrapper>
            )}
        </BrowserRouter>
    </React.StrictMode>
);
